var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitebell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4706_12024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4706_12024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 14.6693C7.63268 14.6693 7.31879 14.5387 7.05768 14.2776C6.79657 14.0165 6.66602 13.7026 6.66602 13.3359H9.33268C9.33268 13.7026 9.20213 14.0165 8.94102 14.2776C8.6799 14.5387 8.36602 14.6693 7.99935 14.6693ZM2.66602 12.6693V11.3359H3.99935V6.66927C3.99935 5.74705 4.27713 4.9276 4.83268 4.21094C5.38824 3.49427 6.11046 3.02483 6.99935 2.8026V2.33594C6.99935 2.05816 7.09657 1.82205 7.29102 1.6276C7.48546 1.43316 7.72157 1.33594 7.99935 1.33594C8.27713 1.33594 8.51324 1.43316 8.70768 1.6276C8.90213 1.82205 8.99935 2.05816 8.99935 2.33594V2.5526C8.88824 2.77483 8.8049 3.00816 8.74935 3.2526C8.69379 3.49705 8.66602 3.74705 8.66602 4.0026C8.66602 4.92483 8.99102 5.71094 9.64102 6.36094C10.291 7.01094 11.0771 7.33594 11.9993 7.33594V11.3359H13.3327V12.6693H2.66602ZM11.9993 6.0026C11.4438 6.0026 10.9716 5.80816 10.5827 5.41927C10.1938 5.03038 9.99935 4.55816 9.99935 4.0026C9.99935 3.44705 10.1938 2.97483 10.5827 2.58594C10.9716 2.19705 11.4438 2.0026 11.9993 2.0026C12.5549 2.0026 13.0271 2.19705 13.416 2.58594C13.8049 2.97483 13.9993 3.44705 13.9993 4.0026C13.9993 4.55816 13.8049 5.03038 13.416 5.41927C13.0271 5.80816 12.5549 6.0026 11.9993 6.0026Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitebell);
export default __webpack_public_path__ + "static/media/whitebell.49d8a16dc4cadc63ab5ca661d2ccdd5d.svg";
export { ForwardRef as ReactComponent };